import axios from './axios';

export const getAccessToken = (code: string, partner: string) => {
  return axios.get(`/oauth`, {params: {code, partner}});
};

export default {getAccessToken};
